import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcSwitch from '@/views/Automation/CampaignCreatorV2/components/CcSwitch/CcSwitch.ts.vue';
import { Icons } from '@/views/Automation/CampaignCreatorV2/helpers/icons';
import { CardType } from '@/views/Automation/CampaignCreatorV2/types';

interface Props {
  title: string;
  icon?: {
    type: Icons;
    fillStyle?: boolean;
  };
  abTest?: boolean;
  switchable?: boolean;
  enabledCard?: boolean;
  type?: CardType;
  info?: string;
}

interface Emits {
  (e: 'enabledCardChange', value: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcCard.ts',
  props: {
    title: null,
    icon: { default: () => ({ type: 'cardInfo', fill: false }) },
    abTest: { type: Boolean, default: false },
    switchable: { type: Boolean, default: false },
    enabledCard: { type: Boolean },
    type: null,
    info: null
  },
  emits: ["enabledCardChange"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'enabledCardChange', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {





function onSwitchChange(value: boolean) {
  emits('enabledCardChange', value);
}

return { __sfc: true,emits, onSwitchChange, CcIcon, CcSwitch, CardType }
}

})